import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// ✅ Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    return { id: decodedToken.subTenantId };
  }
  return null;
};

// ✅ Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  // only tenant-admin OR if subTenantId is missing
  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const CoolingProcessApi = {
  // Create CoolingProcess Api
  CreateCoolingProcess: (data) => {
    let jsonData = JSON.parse(data);

    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) {
      jsonData.subTenantDTO = subTenantDTO;
    }

    return apiApp
      .post(`/cooling-processes`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // Put CoolingProcess Api
  PutCoolingProcess: (CoolingProcessId, data) => {
    let jsonData = JSON.parse(data);

    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) {
      jsonData.subTenantDTO = subTenantDTO;
    }

    return apiApp
      .put(`/cooling-processes/${CoolingProcessId}`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // List CoolingProcess Api
  ListCoolingProcess: (page, limit) => {
    return apiApp
      .get(
        `/cooling-processes?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // Single CoolingProcess Api
  SingleCoolingProcess: (CoolingProcessID) => {
    return apiApp
      .get(
        `/cooling-processes/${CoolingProcessID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },
};

export default CoolingProcessApi;
